import React from 'react';
import Modal from './components/Modal/index.js';
import { C as CarouselComponent } from './Carousel-wPZBp8CD.js';

const Lightbox = ({ items = [], currentImageIndex, title = '', onClose }) => (React.createElement(Modal, { open: true, maxWidth: "lg", title: title, className: "base-image-carousel-modal", onClose: onClose },
    React.createElement(CarouselComponent, { items: items, currentIndex: currentImageIndex, title: title, isLightbox: true })));

export { Lightbox as L };
//# sourceMappingURL=Lightbox-qa-xYGH2.js.map
